import React from "react";
import { ListaFuncionarios } from "../../components/ListaFuncionarios";

export const ListaAssinantes: React.FC = () => {
  return <ListaFuncionarios />;
};
